import '../../App.scss'
import React, { useState } from 'react'
import { withRouter } from 'react-router-dom'
import { useHistory } from 'react-router'
import Fade from 'react-reveal/Fade';
function NavBar() {
  const history = useHistory()
  const [navigation] = useState({
    item: [
      {
        name: "Home",
        path: '/',
      },
      // {
      //   name: "Events",
      //   path: '/events',
      // },
      // {
      //   name: "News",
      //   path: '/news',
      // },
      {
        name: "Museum",
        path: '/museum',
      },
      {
        name: "Articles",
        path: '/articles',
      },
      {
        name: "Mystery Glyphs",
        path: '/mysteryglyphs/',
      },
      {
        name: "About",
        path: '/about',
      },
      {
        name: "Community",
        path: '/community',
      }

    ]
  })
  const [menu, setToggle] = useState(false)
  const toggleMenu = () => setToggle(!menu)
  return (
    <div className="NavHolder">
      <div className="DesktopNav">
        <header className="NavBar">
          <div className="LogoBox" onClick={()=>history.push('/')}>
            <img id="NavLogo" src="https://lh3.googleusercontent.com/pw/ACtC-3dJ1fbLEDPaTz3M3hMspfsH378kQdHepH4S2HquWx-LFmLwlYAjUW-Ek4zy-cmo4nGNUyi80UQJM-xEV3wSEWGy54SkDJNnecg2ON37nQxtcmzrfcxvBPksqtS97ELI_gXQeSALqRPiEkECgnvL7J1qCA=s800-no?authuser=0" alt="AHRF Logo">
            </img>
            <h1>Ancient Historical <br></br>Research Foundation</h1>


          </div>
          <div className="NavList">
            {navigation.item.map((data, index) => (
              <div onClick={()=>history.push(data.path)}className="NavItem">
                <h2>
                  {data.name}
                </h2>
              </div>
            ))}
          </div>
          {/* <div className="SearchBox">
            <input placeholder="search"></input>
          </div> */}
        </header>
      </div>
      <div className="MobileNav">
        <header className="NavBar">
          <div className="LogoBox">
            <img id="NavLogo" src="https://lh3.googleusercontent.com/pw/ACtC-3dJ1fbLEDPaTz3M3hMspfsH378kQdHepH4S2HquWx-LFmLwlYAjUW-Ek4zy-cmo4nGNUyi80UQJM-xEV3wSEWGy54SkDJNnecg2ON37nQxtcmzrfcxvBPksqtS97ELI_gXQeSALqRPiEkECgnvL7J1qCA=s800-no?authuser=0" alt="AHRF Logo">
            </img>
            <h1>Ancient Historical <br></br>Research Foundation</h1>
            <div onClick={()=>toggleMenu()} className="Hamburger">
              <div className="BurgerLine">

              </div>
              <div className="BurgerLine">
              </div>
              <div className="BurgerLine">

              </div>
            </div>
          </div>
            <Fade cascade bottom>
          <div className={`NavListMobile-${menu.toString()}`}>
            {navigation.item.map((data, index) => (
              <div onClick={() => {
                history.push(data.path)
                toggleMenu()
            }} className="NavItemMobile">
                <h2>
                  {data.name}
                </h2>
              </div>
            ))}
          </div>
            </Fade>
        </header>
      </div>
    </div>
  );
}
export default withRouter(NavBar)